
import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Download, X, FileImage, FileText } from "lucide-react";

interface RevenueFormatDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onDownload: (format: 'jpg' | 'pdf') => void;
  title: string;
  description: string;
}

const RevenueFormatDialog = ({ 
  isOpen, 
  onClose, 
  onDownload,
  title,
  description
}: RevenueFormatDialogProps) => {
  const [selectedFormat, setSelectedFormat] = useState<'jpg' | 'pdf'>('jpg');

  const handleDownload = () => {
    onDownload(selectedFormat);
    onClose();
  };

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      onClose();
    }
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleOpenChange}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center justify-between">
            {title}
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="h-6 w-6 p-0"
            >
              <X className="h-4 w-4" />
            </Button>
          </DialogTitle>
          <DialogDescription>
            {description}
          </DialogDescription>
        </DialogHeader>
        
        <div className="space-y-4">
          <div className="text-sm text-muted-foreground">
            Select download format:
          </div>
          <div className="grid grid-cols-2 gap-4">
            <Button
              variant={selectedFormat === 'jpg' ? 'default' : 'outline'}
              onClick={() => setSelectedFormat('jpg')}
              className="h-20 flex flex-col gap-2"
            >
              <FileImage className="h-6 w-6" />
              <span>JPG Image</span>
            </Button>
            <Button
              variant={selectedFormat === 'pdf' ? 'default' : 'outline'}
              onClick={() => setSelectedFormat('pdf')}
              className="h-20 flex flex-col gap-2"
            >
              <FileText className="h-6 w-6" />
              <span>PDF Document</span>
            </Button>
          </div>

          <div className="flex justify-end space-x-2 pt-4 border-t">
            <Button variant="outline" onClick={onClose}>
              Cancel
            </Button>
            <Button onClick={handleDownload}>
              <Download className="w-4 h-4 mr-2" />
              Download
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default RevenueFormatDialog;
